import PropTypes from 'prop-types';
import React from 'react';
import { GridItem } from '../../fuse-responsive-grid/src/grid';
import {
	StyledCardGroup,
	StyledDescription,
	StyledTextWrapper,
	StyledTitle,
} from './styled-card-group';

const defaultProps = {
	className: 'fuse-card-group',
	dataTestId: 'fuse-card-group-test-id',
	description: undefined,
	lColumns: 3,
	mColumns: 3,
	title: undefined,
	titleTag: 'h2',
	xxsColumns: 1,
};

const propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	description: PropTypes.string,
	lColumns: PropTypes.oneOf([2, 3, 4]),
	mColumns: PropTypes.oneOf([2, 3, 4]),
	title: PropTypes.string,
	titleTag: PropTypes.string,
	xxsColumns: PropTypes.oneOf([1, 2]),
};

function CardGroup({
	className,
	title,
	titleTag,
	description,
	xxsColumns,
	mColumns,
	lColumns,
	children,
	dataTestId,
	...props
}) {
	const hasText = title || description;

	return (
		<StyledCardGroup className={className} data-testid={dataTestId} {...props}>
			{hasText && (
				<StyledTextWrapper xxs="12">
					{title && (
						<StyledTitle size={{ xxs: '3', m: '4', l: '5' }} tag={titleTag} type="heading">
							{title}
						</StyledTitle>
					)}
					{description && (
						<StyledDescription size="1" type="paragraph">
							{description}
						</StyledDescription>
					)}
				</StyledTextWrapper>
			)}
			{children.map((card, i) => (
				<GridItem
					// eslint-disable-next-line react/no-array-index-key
					key={i}
					className="fuse-card-group__grid-item-content"
					data-testid={`fuse-card-group-grid-item-content-${i}`}
					xxs={xxsColumns ? 12 / xxsColumns : '12'}
					m={mColumns ? 12 / mColumns : '4'}
					l={lColumns ? 12 / lColumns : '4'}
				>
					{card}
				</GridItem>
			))}
		</StyledCardGroup>
	);
}

CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;

export { CardGroup };
export default CardGroup;
